export default __webpack_public_path__ + "static/media/ktranslate.c0efd5df.png";